module.exports = __webpack_public_path__ + "img/168.61a15faa.jpg";